import axios from 'axios'
import { unwrapApiEnvelope } from '@/shared/lib/api-envelope'
import { buildApiUrl } from '@/shared/lib/api-origin'
import { clearAuthToken, getAuthToken } from '@/shared/lib/auth-token'

/**
 * Consumer client for the generic `/api/notifications/` endpoints.
 *
 * Notifications are a top-level mount (not under `/api/consumer`), so the
 * consumer SPA reaches them through this dedicated instance rather than the
 * `@/consumer/lib/api` client whose baseURL is hardcoded to `/api/consumer`.
 * Same X-Session-Token transport and envelope-unwrapping as the consumer API
 * client, so hooks read flat payloads exactly like their admin counterparts.
 */
const notificationsApi = axios.create({
  baseURL: buildApiUrl('/api/notifications'),
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' },
})

notificationsApi.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) {
    config.headers['X-Session-Token'] = token
  }
  return config
})

notificationsApi.interceptors.response.use(
  (response) => unwrapApiEnvelope(response),
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      clearAuthToken()
    }
    return Promise.reject(error)
  },
)

export default notificationsApi
